"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext } from "use-context-selector";
import { useWindowSize } from "../../hooks";
export const createSizeProvider = ({
  initialWindowSize
}) => {
  const defaultSize = initialWindowSize || {
    height: 0,
    width: 0
  };
  const SizeContext = createContext(defaultSize);

  /*
   * Creates a ContextProvider for a centralized source of screen width/height.
   *
   * This ensures there is only a single event listener attached for the resize event and not one for each component.
   *
   * IMPORTANT: Its important to write a specialised context selector to only get the value you care about (e.g isLessThanMd) instead
   * of subscribing to the width/height directly. This ensures that the component will re-render only if the actual value of the breakpoint changes,
   * and not on every resize event.
   */
  const SizeProvider = t0 => {
    const $ = _c(3);
    const {
      children
    } = t0;
    const windowSize = useWindowSize(initialWindowSize);
    let t1;
    if ($[0] !== children || $[1] !== windowSize) {
      t1 = <SizeContext.Provider value={windowSize}>{children}</SizeContext.Provider>;
      $[0] = children;
      $[1] = windowSize;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  };
  return {
    SizeProvider,
    SizeContext
  };
};